<footer>
    <div class="section-sm bg-dark">
        <div class="container">
            <div class="row g-4 align-items-center">
                <div class="col-12 col-md-6 text-center text-md-start">
                    <p class="mt-2">&copy; 2025 Helifax, All Rights Reserved.</p>
                </div>
                <div class="col-12 col-md-6 text-center text-md-end">
                    <ul class="list-inline-sm mt-3 mt-lg-4">
                        <li *ngFor="let social of socialIcons">
                            <a class="button-circle button-circle-sm" [ngClass]="'button-circle-social-' + social.name" routerLink="/home-one">
                                <i class="bi" [ngClass]="'bi-' + social.icon"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div><!-- end row -->
        </div><!-- end container -->
    </div>
</footer>